import { setProperty } from "dot-prop";

export function isEmptyValue(v: unknown): boolean {
  return (
    v === undefined || v === null || v === "" || v === false || Number.isNaN(v)
  );
}

/*
 * Transform list of dot notation keys into a nested object
 *
 */
export function unflatten<T>(base: Record<string, unknown>): T {
  const result = {};

  for (const [key, value] of Object.entries(base)) {
    setProperty(result, key, value);
  }

  return result as T;
}
